import React from 'react'
import { Avatar, Box, RowsSkeletonLoader } from '@node-space/ui-components'
import { CustomerWallet } from 'types/customers'
import { roundNumberWithCommas } from 'utils/utils'

interface CustomerWalletPageHeaderProps {
  customerWallet: CustomerWallet
  isLoading: boolean
}

const CustomerWalletPageHeader = ({ customerWallet, isLoading }: CustomerWalletPageHeaderProps) => {
  return isLoading ? (
    <Box width="full" flex>
      <Box className="w-40 h-8">
        <RowsSkeletonLoader rows={1} />
      </Box>
    </Box>
  ) : (
    <Box width="full" flex className="py-3">
      <Avatar size="small" name={customerWallet?.balance?.currencyCode} />

      <Box flexSize="fill" paddingL={16} gapY={4}>
        <h1 className="text-h1 text-foreground-prominent leading-6">
          {`${roundNumberWithCommas(Number(customerWallet?.balance?.value) || 0, 2)} ${customerWallet?.balance?.currencyCode}`}
        </h1>
      </Box>
    </Box>
  )
}

export default CustomerWalletPageHeader
